import Header from "../components/Header";
import React from "react";
import { Helmet } from "react-helmet";
import pic1 from "../assets/images/pic1.jpg";
import Footer from "../components/Footer";
import im21 from "../assets/images/im21.jpg";
import im18 from "../assets/images/im18.jpg";
import ow1 from "../assets/images/ow1.jpg";

const brands = [
  "Zeiss",
  "Essilor",
  "Rodenstock",
  "Vision Rx",
  "Nova",
  "Kodak",
  "Vogue",
  "Tom Ford",
  "Ray-Ban",
  "Carrera",
  "Police",
  "Boss",
  "Mont Blanc",
];

export default function About() {
  return (
    <>
      <Helmet>
        <title>
          Aram Eye Opticals | Best Eyeglasses & Eye Testing in Chinnasalem
        </title>
        <meta
          name="description"
          content="Aram Eye Opticals offers premium eyeglasses, sunglasses, and eye testing services in Chinnasalem. Visit our optical shop for anti-glare lenses, contact fittings, and branded eyewear."
        />
        <meta
          name="keywords"
          content="frames for male, Stylish glasses for men, Best frames for men, Sunglasses for men, Best optical for men, Optical for men price, Frames for glasses for Male, Stylish Specs Frame For boy, Trendy eyeglasses for boys, Modern spectacle frames for male, Lightweight frames for men, Designer glasses for men, Durable spectacle frames for male, Rimless glasses for men, Rectangle frames for men, Round glasses for boys, Semi-rimless specs for men, Polarized sunglasses for men, UV-protected sunglasses, Sports sunglasses for men, Affordable glasses for boys, Cheap specs for men online, Branded glasses under ₹1000, Eyewear for men low price, Ray-Ban frames for men, Lenskart men’s collection, Oakley sunglasses for men, Titan Eyeplus frames for male, Computer glasses for men, Blue light glasses for boys, Prescription glasses for men, Gaming glasses for boys, Anti-glare specs for men, Glasses for men with round face, Spectacles for professionals"
        />
        <link rel="canonical" href="https://yourdomain.com/about" />
        <meta
          property="og:title"
          content="Aram Eye Opticals – Trusted Eyecare in Chinnasalem"
        />
        <meta
          property="og:description"
          content="Top optical shop for branded eyewear, eye testing, and contact lenses in Tamil Nadu."
        />
        <meta property="og:url" content="https://yourdomain.com/about" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://yourdomain.com/images/founder.jpg"
        />

        {/* JSON-LD Structured Data for SEO */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "Optician",
              "name": "Aram Eye Opticals",
              "image": "https://yourdomain.com/images/founder.jpg",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "43/9A, Moongilpadi Rd",
                "addressLocality": "Chinnasalem",
                "addressRegion": "Tamil Nadu",
                "postalCode": "606201",
                "addressCountry": "IN"
              },
              "telephone": "+91-9600481947",
              "email": "aramprimaryeyecare@gmail.com",
              "url": "https://yourdomain.com",
              "description": "Visit Aram Eye Opticals in Chinnasalem for branded eyeglasses, anti-blue light lenses, eye testing, and prescription sunglasses."
            }
          `}
        </script>
      </Helmet>
      <Header />
      <div className="scroll-container text-white">
        <div className="scroll-content">
          {/* First set of brand names */}
          {brands.map((brand, index) => (
            <div
              key={`brand-1-${index}`}
              className="scroll-item text-center text-lg font-semibold p-2"
            >
              {brand}
            </div>
          ))}
          {/* Duplicate set of brand names for seamless scrolling */}
          {brands.map((brand, index) => (
            <div
              key={`brand-2-${index}`}
              className="scroll-item text-center text-lg font-semibold p-2"
            >
              {brand}
            </div>
          ))}
        </div>
      </div>

      <div className="flex flex-col items-center justify-center text-center px-4">
        <h1 className="text-4xl Rubik-Bold mt-6 text-black AboutUs-heading">
          About Aram Eye Opticals
        </h1>
        <p className="mt-4 text-gray-500 text-lg">
          Welcome to Aram Eye Opticals! We offer a wide range of high-quality
          lenses and frames from leading brands to meet your eyewear needs.
        </p>
      </div>

      <div>
        {/* Section 1 */}
        <div className="flex flex-col md:flex-row items-center my-8 px-4">
          <div className="flex-1 mb-4 md:mb-0">
            <img src={im21} alt="best opticals" className="w-full rounded-lg" />
          </div>
          <div className="flex-1 px-4">
            <h2 className="text-lg Rubik-light mt-4 text-lightgreen-600">
              Empowering Success
            </h2>
            <h3 className="text-3xl md:text-4xl font-bold mt-4 text-black">
              Enhance your vision with our Aram Eyecare
            </h3>
            <p className="text-base md:text-lg Rubik-light mt-4 text-gray-600">
              Aram Eyecare and Opticals was founded in October 2021 in
              Chinnasalem by Mohamed Thaha Musthafa, a Bachelor of Science in
              Optometry. From the outset, Aram Eyecare aimed to carve a unique
              path, focusing on clinical practice rather than just being a
              conventional optical store. As a new startup, Aram faced the
              challenge of standing out in a market dominated by cheaper,
              lower-quality products. Despite these struggles, Aram’s commitment
              to providing top-notch brands and quality products has helped
              establish it as a trusted name in eyecare.
              <br />
            </p>
            <div className="flex flex-col md:flex-row gap-4 mt-6">
              <div className="flex-1 bg-blue-200 p-4 rounded-lg shadow-lg">
                <h2 className="Rubik-Bold">Strong Foundation</h2>
                <p className="text-sm">
                  A strong foundation in both dispensing optometry and clinical
                  knowledge, Founder Thaha is dedicated to ensuring that every
                  patient receives personalized care and satisfaction, not only
                  from the service but also from the products they choose.
                  Today, Aram Eyecare has expanded to three branches across
                  three different districts, becoming the preferred choice for
                  eye care in the region.
                </p>
              </div>
              <div className="flex-1 bg-blue-200 p-4 rounded-lg shadow-lg">
                <h2 className="AboutUs-heading-sub Rubik-Bold">
                  Quality Of Vision
                </h2>
                <p className="text-sm">
                  At the heart of Aram Eyecare is the belief that "Quality of
                  vision determines the confidence of life," and this principle
                  drives us to deliver exceptional care and products, ensuring
                  every patient’s vision is treated with the utmost attention
                  and expertise.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Section 2 */}
      <div className="flex flex-col items-center justify-between text-center bg-gray-100 p-6 md:p-4">
        <div className="flex flex-col md:flex-row items-center gap-4 my-6 px-2">
          {/* Text Content */}
          <div className="flex-1 px-20 order-2 md:order-1 text-sm md:text-base">
            <h1 className="text-2xl md:text-3xl font-bold text-black mb-2 md:mb-4">
              Founder Of Aram Eyecare
            </h1>
            <p className="text-gray-700 text-sm md:text-lg leading-6 md:leading-7">
              <span className="Rubik-Bold">Founder:</span> Mohamed Thaha
              Musthafa
              <br />
              <span className="Rubik-Bold">Qualification:</span> Bachelor of
              Science in Optometry
              <br />
              <br />
              <span className="Rubik-Bold">Role and Vision:</span>
              <br />
              Founded Aram Eyecare and Opticals in October 2021 in Chinnasalem.
              Dedicated to ensuring that every patient receives personalized
              care and satisfaction through both service and high-quality
              products. Strong foundation in dispensing optometry and clinical
              knowledge. Focused on clinical practice, setting Aram apart from
              conventional optical stores.
            </p>
          </div>

          {/* Image */}
          <div className="flex-1 mb-2 md:mb-0 order-1 md:order-2 flex justify-end px-12">
            <img
              src={ow1}
              alt="Best Optical Store"
              className="rounded-lg h-96 shadow-lg shadow-gray-400/50 object-contain"
            />
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 p-6">
        {/* First Widget */}
        <div className="bg-white p-6 flex items-center justify-center">
          <img
            src={im18}
            alt="Best Glasses"
            className="rounded-lg shadow-lg shadow-indigo-500/50  object-cover h-1/2 max-w-lg"
          />
        </div>

        {/* Second Widget */}
        <div className="bg-white p-6 flex flex-col justify-center">
          <h1 className="text-4xl Rubik-Bold mt-6 text-black text-center unl">
            Optometrists
          </h1>
          <p className="text-gray-600 mt-4 text-justify Rubik-Light text-xl">
            Optometrists can diagnose and treat the most common issues that
            affect your eyes. If you need a surgical procedure, they’ll probably
            refer you to an ophthalmologist or surgeon. No matter which type of
            eye care specialist you need, make sure you visit a healthcare
            provider as soon as you notice any changes in your eyes or vision.
          </p>
        </div>
      </div>
      <div style={{ display: "none" }}>
        frames for male, Stylish glasses for men, Best frames for men,
        Sunglasses for men, Best optical for men, Optical for men price, Frames
        for glasses for Male, Stylish Specs Frame For boy, Trendy eyeglasses for
        boys, Modern spectacle frames for male, Lightweight frames for men,
        Designer glasses for men, Durable spectacle frames for male, Rimless
        glasses for men, Rectangle frames for men, Round glasses for boys,
        Semi-rimless specs for men, Polarized sunglasses for men, Best
        UV-protected sunglasses for boys, Sports sunglasses for men, Black
        aviator sunglasses for male, Stylish shades for boys, Driving sunglasses
        for men, Affordable glasses for boys, Cheap specs for men online,
        Branded glasses under ₹1000, Eyewear for men low price, Best budget
        optical frames for boys, Ray-Ban frames for men, Lenskart men’s
        collection, Oakley sunglasses for men, Titan Eyeplus frames for male,
        Fastrack specs for boys, Computer glasses for men, Blue light glasses
        for boys, Reading glasses for male, Prescription glasses for men, Gaming
        glasses for boys, Anti-glare specs for men, Where to buy stylish glasses
        for men near me, Best optical shop for men in Chinnasalem, Affordable
        specs for boys in Chinnasalem, Buy men’s eyewear online in India,
        Spectacle showroom for men near Moongilpadi Road, Eyeglasses for working
        professionals men, Eyewear for college boys, Glasses for men with round
        face, Trendy glasses for teenage boys, Frames for corporate men, Premium
        eyewear for businessmen, Casual frames for everyday wear male
      </div>

      <Footer />
    </>
  );
}
